import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';
import InfoIcon from '../../../../assets/icons/i_circular_icon.svg';
import InfoIconOrange from '../../../../assets/icons/i_circular_icon_orange.svg';

export const Content = styled.div`
    display: none;
    position: absolute;
    bottom: 100%;
    background-color: #343A40;
    width: max-content;
    max-width: 250px;
    filter: drop-shadow(0px 2px 8px rgba(0, 0, 0, 0.1));
    border-radius: 2px;
    padding: 12px;
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 12px;
    line-height: 130%;
    color: ${colors.WHITE};

    &::before {
        content: " ";
        position: absolute;
        top: 100%;
        left: 50%;
        border-radius: 0 0 1px 0;
        margin-top: -4px;
        margin-left: -4px;
        width: 8px;
        height: 8px;
        background-color: #343A40;
        transform: rotate(45deg);
    }
`;

export const Container = styled.div`
    position: relative;
    width: 16px;
    height: 16px;
    background-image: url(${InfoIcon});
    background-repeat: no-repeat;
    cursor: pointer;
    display: flex;
    justify-content: center;

    &:hover {
        background-image: url(${InfoIconOrange});

        ${Content} {
            display: block;
        }
    }
`;
